import moment from "moment";
import _ from "lodash";

import translate from "../../../helpers/translate";
import { hotelsCRMURI } from "../../../config";
const formatDate = (data) =>
  data.value && moment(data.value).format("DD/MM/YYYY");

export default translate({
  archivePage: {
    columnDefs: [
      {
        headerName: "actions",
        field: "actions",
        pinned: "left",
        hide: false,
        cellRenderer: "actionsRenderer",
        cellRendererParams: (params) => {
          const { _hotel, _id, recipientId } = params.data;
          return {
            seenWarning: true,
            link: `${hotelsCRMURI}${_hotel.slug}/group/${_id}/${recipientId}?portal=true`,
          };
        },
        width: 100,
        resizable: false,
        suppressSizeToFit: true,
        filter: false,
        sortable: false,
        floatingFilter: false,
      },
      {
        headerName: "hotel",
        field: "_hotel.name",
        pinned: "left",
      },
      {
        headerName: "cooperation",
        field: "cooperation",
        pinned: "left",
      },
      {
        headerName: "title",
        field: "title",
      },
      {
        headerName: "arrival",
        field: "arrival",
        width: 80,
        cellRenderer: formatDate,
      },
      {
        headerName: "departure",
        field: "departure",
        width: 80,
        cellRenderer: formatDate,
      },
      {
        headerName: "releaseDate",
        field: "releaseDate",
        width: 80,
        cellRenderer: formatDate,
      },
      {
        headerName: "status",
        field: "status",
        cellRenderer: "statusRenderer",
        cellStyle: {
          textAlign: "center",
        },
        width: 120,
      },
      {
        headerName: "pax",
        field: "pax",
        cellEditor: "numericEditor",
        width: 120,
      },
      {
        headerName: "paid",
        field: "paid",
        cellRenderer: ({ data }) => _.sumBy(data.payments, (p) => p.amount),
      },
      {
        headerName: "sent",
        field: "sent",
        width: 120,
        cellRenderer: "sentRenderer",
      },
      {
        headerName: "seen",
        field: "seen",
        width: 120,
        cellRenderer: "seenRenderer",
      },
      {
        headerName: "createdOn",
        field: "_createdOn",
        width: 80,
        cellRenderer: formatDate,
      },
      {
        headerName: "files",
        field: "files",
        cellRenderer: "filesRenderer",
        width: 80,
      },
    ],
    defaultColDefs: {
      filter: true,
      sortable: true,
      resizable: true,
      floatingFilter: true,
    },
  },
});
